export default () => {
    window.addEventListener('elementor/frontend/init', function() {
        console.log("elementor/init")
        if (elementorFrontend && !elementorFrontend.isEditMode() && !elementorFrontend.isWPPreviewMode()) {
            elementorFrontend.storage.get = function() {};
            elementorFrontend.storage.set = function() {};

            if (window.sessionStorage) {
            window.sessionStorage.removeItem('elementor');
            }

            if (window.localStorage) {
            window.localStorage.removeItem('elementor');
            }
        }
    });
}
